import React, { useState } from 'react';
import './Gallery.css';

function Gallery() {
  const [selectedIframe, setSelectedIframe] = useState('default');

  const handleIframeChange = (eventKey) => {
    setSelectedIframe(eventKey);
  };

  const renderIframe = () => {
    if (selectedIframe === 'dashain2019') {
      return (
        <iframe
          src="https://drive.google.com/embeddedfolderview?id=1XezkvtFH59b9VkS83ItPHQYtCtvWNFC7#grid"
          title="Google Drive Folder Dashain 2019"
          width="100%"
          height="600"></iframe>
      );
    } else if (selectedIframe === 'holi2019') {
      return (
        <iframe
          src="https://drive.google.com/embeddedfolderview?id=1DFsOqfh0PqzBGYrJpKr11FtXZRECLtBv#grid"
          title="Google Drive Folder Holi 2019"
          width="100%"
          height="600"></iframe>
      );
    } else if (selectedIframe === 'dashain2022') {
      return (
        <iframe
          src="https://drive.google.com/embeddedfolderview?id=1G0euCunT9Pke1T7QNqwaUW0crekQdkWy#grid"
          title="Google Drive Folde Dashain 2022"
          width="100%"
          height="600"></iframe>
      );
    } else if (selectedIframe === 'holi2023') {
      return (
        <iframe
          src="https://drive.google.com/embeddedfolderview?id=19VGHOy4czDTWIdvON6N2ICLrfUQ78g4m#grid"
          title="Google Drive Folder Holi 2023"
          width="100%"
          height="600"></iframe>
      );
    } else if (selectedIframe === 'henna') {
      return (
        <iframe
          src="https://drive.google.com/embeddedfolderview?id=0B477XQoj-6uLRWptVnRiWDd1eUE#grid"
          title="Google Drive Folder Henna"
          width="100%"
          height="600"></iframe>
      );
    } else {
      return (
        <iframe
          src="https://drive.google.com/embeddedfolderview?id=1XezkvtFH59b9VkS83ItPHQYtCtvWNFC7#grid"
          title="Google Drive Folder"
          width="100%"
          height="600"></iframe>
      );
    }
  };

  return (
    <div className="container">
      <div className="dropdown text-center">
        <button
          className="btn btn-outline-success dropdown-toggle"
          type="button"
          id="dropdownMenuButton"
          data-bs-toggle="dropdown"
          aria-expanded="false">
          {selectedIframe === 'default' ? 'Select an event' : selectedIframe.toUpperCase()}
        </button>
        <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
          <li>
            <a className="dropdown-item" href="#" onClick={() => handleIframeChange('default')}>
              Default
            </a>
          </li>
          <li>
            <a className="dropdown-item" href="#" onClick={() => handleIframeChange('dashain2019')}>
              Dashain 2019
            </a>
          </li>
          <li>
            <a className="dropdown-item" href="#" onClick={() => handleIframeChange('holi2019')}>
              Holi 2019
            </a>
          </li>
          <li>
            <a className="dropdown-item" href="#" onClick={() => handleIframeChange('dashain2022')}>
              Dashain 2022
            </a>
          </li>
          <li>
            <a className="dropdown-item" href="#" onClick={() => handleIframeChange('holi2023')}>
              Holi 2023
            </a>
          </li>
          <li>
            <a className="dropdown-item" href="#" onClick={() => handleIframeChange('henna')}>
              Henna Design
            </a>
          </li>
        </ul>
      </div>

      {renderIframe()}
    </div>
  );
}

export default Gallery;
